import { tt } from '@agos/shared'
import type { BadgeColor } from '@agos/ui'

/**
 * The order status vocabulary, shared by every screen in this module.
 *
 * The colours are learned: amber means "in preparation" on the kitchen board,
 * the dispatch board and the archive alike, and a member of staff reads them
 * across the room without reading the word. They are ported unchanged.
 */

// §9.149 — the labels now live in `@agos/shared`; two modules draw them and only one owned them.
export { ORDER_STATUS_LABELS, orderStatusLabel } from '@agos/shared'


export const ORDER_STATUS_BADGE_COLORS: Record<string, BadgeColor> = {
  pending: 'amber',
  new: 'blue',
  confirmed: 'cyan',
  preparing: 'amber',
  quality_check: 'cyan',
  ready: 'orange',
  on_the_way: 'violet',
  at_address: 'orange',
  delivered: 'emerald',
  cancelled: 'red',
}

export function orderStatusColor(status: string | undefined): BadgeColor {
  if (!status) return 'zinc'
  return ORDER_STATUS_BADGE_COLORS[status] ?? 'zinc'
}

/** An order that is neither delivered nor cancelled is still being worked. */
export const CLOSED_ORDER_STATUSES = ['delivered', 'cancelled']

export function isOrderClosed(status: string | undefined): boolean {
  return CLOSED_ORDER_STATUSES.includes(status ?? '')
}

/**
 * The three channels legacy hardcodes. BACKEND.md §10A.1 replaced them with
 * franchise-managed `sales_channels`, and §9.5 replaces this map with a channel
 * lookup — after parity. `bar` is labelled *Osobný odber* here because that is
 * what the screens say, even though the backend calls the channel BAR.
 */
export const ORDER_TYPE_LABELS: Record<string, string> = {
  delivery: tt('Rozvoz'),
  restaurant: tt('Reštaurácia'),
  bar: tt('Osobný odber'),
}

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  cash: tt('Hotovosť'),
  card_terminal: tt('Karta terminál'),
  card_courier: tt('Karta kuriér'),
  card_online: tt('Online'),
  card: tt('Karta'),
}

export function paymentMethodLabel(method: string | undefined): string {
  if (!method) return PAYMENT_METHOD_LABELS.card_online ?? ''
  return PAYMENT_METHOD_LABELS[method] ?? PAYMENT_METHOD_LABELS.card_online ?? ''
}
